import { FC } from 'react';
import { useField } from 'formik';
import { IBaseField } from './BaseField';
import { Text } from 'src/Controls';

interface ITextFieldProps extends IBaseField {
	autoFocus?: boolean;
};

/**
 * Текстовое поле
 */
const TextField: FC<ITextFieldProps> = ( props ) => {
	
	const { name, autoFocus, ...otherProps } = props;
	const [ inputProps, meta ] = useField( name );

	return (
		<Text
			{...otherProps}
			{...inputProps}
			{...meta}
			autoFocus={autoFocus}
		/>
	);
};

export default TextField;
